import React, { useContext, useEffect, useState } from 'react';
import { DashboardContext } from '../../../contexts/states/DashboardState';
import { SuccessHandler } from '../SuccessHandler';
import { GlobalErrorHandler } from '../GlobalErrorHandler';
import { formattedMonth } from '../../../contexts/utils';

export const SideBar = () => {
  const {
    drivers,
    getCarTypePrice,
    currentPrices,
    globalError,
    success,
    toFalse,
    users,
  } = useContext(DashboardContext);

  const [driversMostRides, setDriversMostRides] = useState({});
  const [usersMostRides, setUsersMostRides] = useState({});
  const [monthUsers, setMonthUsers] = useState([]);
  const [mostRated, setMostRated] = useState({});
  const [luxuryCars, setLuxuryCars] = useState(0);
  const [premiumCars, setPremiumCars] = useState(0); // change these to actual cars and not just figures in the future like cars that are premium and stuff

  useEffect(() => {
    if (drivers.length >= 1) {
      const luxuryCars = drivers.filter((driver) => {
        return driver.carType === 'luxury' && driver.status === 'approved';
      });
      setLuxuryCars(luxuryCars.length);
      const premiumCars = drivers.filter((driver) => {
        return driver.carType === 'premium' && driver.status === 'approved';
      });
      setPremiumCars(premiumCars.length);

      // sort and filter drivers rides
      drivers.sort((a, b) => b.completedRides - a.completedRides);
      setDriversMostRides(drivers[0]);

      const driversClone = [...drivers];
      driversClone.sort((a, b) => b.stars.starReceived - a.stars.starReceived);
      setMostRated(driversClone[0]);
    }
  }, [drivers]);

  useEffect(() => {
    if (users.length >= 1) {
      const usersClone = [...users];

      // sort and filter drivers rides
      usersClone.sort((a, b) => b.completedRides - a.completedRides);
      setUsersMostRides(usersClone[0]);

      const monthIndex = new Date().getMonth();

      const monthUsers = [];
      users.forEach((user) => {
        if (user.month - 1 === monthIndex) {
          monthUsers.push(user);
        }
      });
      setMonthUsers(monthUsers);
    }
  }, [users]);

  useEffect(() => {
    getCarTypePrice('premium');
    getCarTypePrice('luxury');
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    let t;
    if (success) {
      t = setTimeout(() => {
        toFalse('SET_SUCCESS');
      }, 3000);
    }

    return () => clearTimeout(t);
    // eslint-disable-next-line
  }, [success]);

  return (
    <div className='sidebar-con'>
      <div className='top'>
        <p className='car-info-intro'>Users</p>
        <div className='car-info cars'>
          <div className='car-type'>
            <div className='icon' style={{ backgroundColor: '#c939ba' }}>
              <i className='fas fa-user'></i>
            </div>
            <div className='car-description'>
              <p className='bold'>All Users</p>
              <p className='tiny'>
                {formattedMonth}: {monthUsers.length}
              </p>
            </div>
            <p className='thin'>{users.length}</p>
          </div>
          <div className='car-type'>
            <div className='icon' style={{ backgroundColor: '#c939ba' }}>
              <i className='fas fa-car'></i>
            </div>
            <div className='car-description'>
              <p className='bold'>Most Rides</p>
              <p className='tiny'>
                {usersMostRides.name ? usersMostRides.name : 'undefined'}
              </p>
            </div>
            <p className='thin'>
              {usersMostRides.completedRides
                ? usersMostRides.completedRides
                : '0'}
            </p>
          </div>
        </div>
        <p className='car-info-intro'>Drivers</p>
        <div className='car-info cars'>
          <div className='car-type'>
            <div className='icon' style={{ backgroundColor: '#4dc939' }}>
              <i className='fas fa-star'></i>
            </div>
            <div className='car-description'>
              <p className='bold'>Most Rated</p>
              <p className='tiny'>{mostRated.name}</p>
            </div>
            <p className='thin'>
              {mostRated.stars?.starReceived}/{mostRated.stars?.overall}
            </p>
          </div>
          <div className='car-type'>
            <div className='icon' style={{ backgroundColor: '#4dc939' }}>
              <i className='fas fa-car'></i>
            </div>
            <div className='car-description'>
              <p className='bold'>Most Rides</p>
              <p className='tiny'>
                {driversMostRides.name ? driversMostRides.name : 'undefined'}
              </p>
            </div>
            <p className='thin'>
              {driversMostRides.completedRides
                ? driversMostRides.completedRides
                : '0'}
            </p>
          </div>
        </div>
        <p className='car-info-intro'>Cars</p>
        <div className='car-info cars'>
          <div className='car-type'>
            <div className='icon'>
              <i className='fas fa-award'></i>
            </div>
            <div className='car-description'>
              <p className='bold'>Luxury Cars</p>
              <p className='tiny'>Price: &#8358;{currentPrices.luxury}</p>
            </div>
            <p className='thin'>{luxuryCars}</p>
          </div>
          <div className='car-type'>
            <div className='icon'>
              <i className='fas fa-award'></i>
            </div>
            <div className='car-description'>
              <p className='bold'>Premium Cars</p>
              <p className='tiny'>Price: &#8358;{currentPrices.premium}</p>
            </div>
            <p className='thin'>{premiumCars}</p>
          </div>
        </div>
      </div>
      <div className='connection-error-handler'>
        <div className={`modal-con ${globalError && 'active'}`}>
          {globalError && (
            <GlobalErrorHandler
              error={`${globalError}!`}
              context={DashboardContext}
            />
          )}
        </div>
      </div>
      <div className='success-handler'>
        <div className={`modal-con ${success && 'active'}`}>
          {success && (
            <SuccessHandler msg={success} context={DashboardContext} />
          )}
        </div>
      </div>
    </div>
  );
};
